import { __, curry, pipe, allPass, all, prop, gt } from "ramda";
var ticketFieldTemplate = curry(function (rowLabel, seatLabel, row, seat) {
  var template =
    "<li class='chosen-ticket'>" +
    "<em class='chosen-ticket-remove'>&times;</em>" +
    "<i class='chosen-ticket-type t-icon-entry_ticket'></i>" +
    '<span class="ticket-seating">' +
    rowLabel +
    " :row, " +
    seatLabel +
    " :seat</span>" +
    "</li>";
  return template.replace(/:row/g, row).replace(/:seat/g, seat);
});
var ticketOptionTemplate = curry(function (title, value) {
  return "<option value='" + value + "'>" + title + "</option>";
});
var itemTypeFactory = function (obj) {
  return function (selector) {
    return function (id) {
      selector.append(
        $(
          "<option value='" +
            obj[id].id +
            "'>" +
            obj[id].title +
            ", " +
            obj[id].price +
            "</option>"
        )
      );
    };
  };
};

var $propInt = function (attr) {
  return function () {
    return parseInt($(this).attr(attr), 10);
  };
};

var seatToKey = function (row, coll) {
  return row + "||" + coll;
};

var selectedSeatsFilterer = function (keys) {
  return function (item) {
    var key = seatToKey(item.row, item.seat);
    return keys.indexOf(key) !== -1;
  };
};

export let seatsManager = (window.seatsManager = curry(function (
  methods,
  $form,
  data
) {
  //globals declaration
  var config = {
    data: data,
    $form: $form,
    submitBtn: $form.find("button[type='submit']"),
    ticketsList: $form.find(".chosen-tickets"),
    ticketFieldTemplateSelected: ticketFieldTemplate(
      $form.attr("data-lang-row"),
      $form.attr("data-lang-place")
    ),
    ticketBlankOptionTemplate: ticketOptionTemplate(
      $("#arena").attr("data-seating-arrangement-select-ticket-type"),
      ""
    ),
    ticketTypeSelector: null,
    tickets: {},
    ticketsUpSelling: {},
    actions: {},
    helpers: {
      selectedSeatsFilterer: selectedSeatsFilterer,
      seatToKey: seatToKey,
      $propInt: $propInt,
      itemTypeFactory: itemTypeFactory,
      ticketOptionTemplate: ticketOptionTemplate,
      ticketFieldTemplate: ticketFieldTemplate,
    },
  };

  methods.checkIfTicketHasEmptyValue = function (config) {
    function hasValue(el) {
      return $(el).val();
    }

    return function () {
      var $ticketTypesSelects = config.$form.find(".ticket-types-select");
      var valid = allPass([pipe(prop("length"), gt(__, 0)), all(hasValue)])(
        $ticketTypesSelects
      );

      config.submitBtn.prop("disabled", !valid);
      return valid;
    };
  };

  for (var methodName in methods) {
    config.actions[methodName] = curry(methods[methodName])(config);
  }

  $form.addClass("order-pane");

  return $.extend({}, { $: $form }, config.actions);
}));
